module.exports = __webpack_public_path__ + "img/唐门男.a54d5aca.png";